{ "imageTag": "20261102073819_7b47459", "buildUri": "vstfs:///Build/Build/103318", "buildId": "103318", "sourceCommit": "7b4745905c0f51d33235b0237045707f45b64588", "sourceBranch": "main", "releaseDate": "2026-11-02T07:47:16Z" }
